export const CommonConstants = {
  apiUrls: {
    getGroupHierarchyTree: 'api/group/getAll',
    getSavedTemplates: 'api/reportTemplate/getAll',
    generateReport: 'api/report/generatereport',
    generateNewReport: 'api/newReports/generatereport',
    getSavedTemplateData: 'api/reportTemplate/get',
    deleteTemplate: 'api/reportTemplate/delete',
    createTemplate: 'api/reportTemplate/create',
    getAvailableGroups: 'api/group/availabledetails',
    editGroupDetails: 'api/group/editgroup',
    addNewGroup: 'api/group/creategroup',
    deleteGroup: 'api/group/deletegroup',
    auth: 'api/auth/login',
    getUserRoles: 'api/role/getAll',
    createUser: 'api/user/create',
    getUser: 'api/user/get',
    deleteUser: 'api/user/delete',
    getAudit: 'api/user/getAudit',
    getStores: 'api/store/getAllStores',
    getSettingsDevices: 'api/store/settingsDevices',
    getDeviceUpgradeDate: 'api/device/getDeviceUpgradeDate',
    getUnregisteredDevices: 'api/device/getAllUnregisterdDevices',
    getMasterSettings: 'api/store/getMasterSettings',
    saveMasterSettings: 'api/store/saveMasterSettings',
    applyMasterSettings: 'api/store/applyMasterSettings',
    getRolesList: 'api/role/get',
    getRoleById: 'api/role/getByID',
    createRole: 'api/role/create',
    updateRole: 'api/role/update',
    deleteRole: 'api/role/delete',
    getPermissions: 'api/permission/getAll',
    getPermissionsList: 'api/permission/getById',
    getUsers: 'api/user/getUsers',
    getAccountInfo: 'api/account/getAccountDetails',
    getCompany: 'api/company/getCompanyDetails',
    getDistributor: 'api/company/getDistributorList',
    getCountry: 'api/country/getAll',
    getBrands: 'api/brand/getall',
    getAdminAcount: 'api/account/getAdminAccount',
    getAdminAccounts: 'api/account/getAdminAccounts',
    getdeviceHistory: 'api/account/getDeviceSettingsHistory',
    getSettingHistoryInfo: 'api/account/getSettingHistoryInfo',
    getRegion: 'api/region/getRegionList',
    saveCompany: 'api/company/saveCompany',
    activateAccount: 'api/account/activateAccount',
    accountValidate: 'api/account/validateUserAccount',
    cancelPremiumSubscription: '/api/account/cancelPremiumSubscription',
    saveAccountInfo: 'api/account/saveAccount',
    agreeAccountTOS: 'api/account/agreeTOS',
    verifycredential: 'api/account/verifycredential',
    saveAdminAccount: 'api/account/saveAdminAccount',
    getCompanyLBVersion: 'api/leaderboard/getCompanyLBVersions',
    updateAdminAccount: 'api/account/updateAdminAccount',
    forgotPassword: 'api/user/forgotPassword',
    resetPassword: 'api/user/resetPassword',
    checkResetPasswordLinkExpiry: 'api/user/checkResetPasswordLinkExpiry',
    getDistributors: 'api/distributor/getAll',
    getDisplaySettings: 'api/displaysettings/getAll',
    getLeaderboard: 'api/Leaderboard/getAll',
    saveDisplaySettings: 'api/displaysettings/update',
    saveLeaderboard: 'api/leaderboard/update',
    getDashboard: 'api/dashboard/getDashboardData',
    downloadReport: 'api/dashboard/downloadReport',
    getStoreranking: 'api/dashboard/getStoreRanking',
    badLoginAttempt: 'api/user/badLoginAttempt',
    getUserDashboardPreferences: 'api/dashboard/getUsePreferences',
    getExpiredAccounts: 'api/account/getExpiredAccounts/',
    getRenewalAccounts: 'api/account/getRenewalAccounts/',
    getFreeAccounts: 'api/account/getFreeAccounts/',
    getStoreDevices: 'api/store/getStoreDevices',
    updateUpgradeLog: 'api/store/updateUpgradeLog',
    getDFAAccount: 'api/user/getDFAAccount',
    checkDFACode: 'api/user/checkDFACode',
    getStore: 'api/store/getStore',
    getAllTimeZones: 'api/timeZone/getAll',
    saveStore: 'api/store/saveStore',
    mergeDevicesInfo: 'api/store/mergeDevicesInfo',
    saveMergeDevices: 'api/store/saveMergeDevices',
    getLBGroups: 'api/lbGroup/getAll',
    getLBgroup: 'api/lbGroup/get',
    getLBgroupsAvailable: 'api/lbGroup/getAvailableStores',
    saveLBGroup: 'api/lbGroup/save',
    deleteLBGroupUser: 'api/lbGroup/deleteLBGroupUser',    
  	checkDevice: 'api/device/checkDevice',    
  	unBindMail: 'api/device/unBindMail',
    deleteLBGroup: 'api/lbGroup/delete',
    deleteLBGroupUser: 'api/lbGroup/deleteLBGroupUser',
    updateLBGroupOwner: 'api/lbGroup/updateLBGroupOwner',
    removeGroup: 'api/lbGroup/removeGroup',
    getLBGroupUsers: 'api/lbGroup/getLBGroupUsers',
    AutoRegisterByEmailAddress: 'AutoRegisterByEmailAddress',
    Unregister: 'Unregister',
    SetSettings: 'SetSettings',
    unRegisterDevices: 'api/store/unRegisterDevicesSearch',
    createLBGroup: 'api/lbgroup/createLBGroup',
    removeLBGroup: 'api/lbgroup/removeLBGroup',
    inviteLBGroupUser: 'api/lbGroup/inviteLBGroupUser',
    inviteResponse: 'api/lbgroup/inviteResponse',
    getLBSubscription: 'api/lbGroup/getLBSubscription',
    removeStore: 'api/store/removeStore',
    removeZoomDevice: 'api/device/removeZoomDevice',
    displayMaintenanceBanner: 'api/notifcations/displayMaintenanceBanner',
    DownloadNewImage: 'api/device/downloadNewImage',
    UnBindRemoteDeviceWeb: 'api/device/unbindRemoteDeviceWeb',
    BindRemoteDeviceWeb: 'api/device/bindRemoteDeviceWeb',
    RestartDevice: 'api/device/restartDevice',
    ForceReconnect: 'api/device/forceReconnect',
	  getLatestInvite: 'api/lbGroup/getRecentInvite',
    inviteResponseFromCloud: 'api/lbGroup/inviteResponseFromCloud',
    createUserSession: 'api/user/createUserSession',
    logger: 'api/logger'
  },
  Api: {
    Facade: {
      RemoteExecution: {
        BindRemoteDeviceWeb: 'BindRemoteDeviceWeb',
        DownloadNewImage: 'DownloadNewImage',
        UnbindRemoteDeviceWeb: 'UnbindRemoteDeviceWeb',
        ForceReconnect: 'ForceReconnect',
        RestartDevice: 'RestartDevice',
        ApplySettingsFromOnetoManyZOOMS: 'ApplySettingsFromOnetoManyZOOMS',
        AutoRegisterByEmailAddress: 'AutoRegisterByEmailAddress',
        Unregister: 'Unregister',
        SetSettings: 'SetSettings',
        RemoveDeviceFromStore: 'RemoveDeviceFromStore'
      }
    }
  },
  TimeMeasureValidations: {
    TwoMonths: 62,
    Month: 31,
    TwoWeeks: 14,
    Today: 0,
    ThreeMonths: 93
  },
  TimeMeasure: {
    Day: 1,
    Daypart: 2,
    Week: 3,
    RawCarData: 4
  },
  Type: {
    Group: 'group',
    Store: 'store'
  },
  Drilldown: [2, 4, 1],
  LaneTotalAvgColors: ['#2790b0', '#eb6841', '#95ba65', '#edc951', '#2b4e72', '#cc333f', '#727272', '#9c347d', '#ff0000', '#00d0f6'],
  LaneTotalAvgColorsImages: ['ldot_2790b0', 'ldot_eb6841', 'ldot_95ba65', 'ldot_edc951', 'ldot_2b4e72', 'ldot_cc333f', 'ldot_727272', 'ldot_9c347d', 'ldot_ff0000', 'ldot_00d0f6'],
  DefaultPermissionIndex: 5,
  isChecked: true,
  value: 'DZCV7UJ6BYVUQVF5B09WU7LI8NU1G0ZG',
  RemoveRoleID: 'FXLR16N255ZQMM6L8QY9LP7F3YN3WZRT',
  RemoveUserID: 'AL2SIAO4K69R7OF83X6HY4SKNUCXTBHQ',
  DashboardTimeMeasures: {
    t1Avg: 'current day avg',
    t1Cars: 'current day cars',
    t1Percent: 'current day percent',

    t2Avg: 'previous day avg',
    t2Cars: 'previous day cars',
    t2Percent: 'previous day percent',

    t3Avg: 'current month avg',
    t3Cars: 'current month cars',
    t3Percent: 'current month percent',

    t4Avg: 'previous month avg',
    t4Cars: 'previous month cars',
    t4Percent: 'previous month percent',

    t5Avg: 'current week avg',
    t5Cars: 'current week cars',
    t5Percent: 'current week percent',

    t6Avg: 'previous week avg',
    t6Cars: 'previous week cars',
    t6Percent: 'previous week percent',

    t7Avg: 'current daypart avg',
    t7Cars: 'current daypart cars',
    t7Percent: 'current daypart percent',

    t8Avg: 'previous dayaprt avg',
    t8Cars: 'previous daypart cars',
    t8Percent: 'previous daypart percent'
  },
  loginAttempts: {
    checkAttemptsTimeout: 20 // In minutes
  },
  currentCU50Version: '3.11',
  StoreSettingsPage: '/settings/stores/viewdetails/',
  RemoteConnectionPermission: 'RemoteConnect',
  RemoveRole: 'RemoveRole',
  EditLeaderboard: 'EditLeaderboard',
  userPermissions: {
    AddRole: 'AddRole',
    AddUser: 'AddUser',
    EditDeviceSettings: 'EditDeviceSettings',
    EditLeaderboard: 'EditLeaderboard',
    EditRole: 'EditRole',
    EditStoreBasic: 'EditStoreBasic',
    EditUser: 'EditUser',
    PerformDeviceRestart: 'PerformDeviceRestart',
    RemoteConnect: 'RemoteConnect',
    RemoveRole: 'RemoveRole',
    RemoveUser: 'RemoveUser',
    ViewAllStores: 'ViewAllStores'
  }
};



// WEBPACK FOOTER //
// ./src/Constants.js